namespace GeniuzPOS.InventoryReport {
    export interface IcReport01_VForm {
    }

    export class IcReport01_VForm extends Serenity.PrefixedContext {
        static formKey = 'InventoryReport.IcReport01_V';
    }
}
